import { Component } from '@angular/core';
// import { NavController, ModalController, NavParams } from '@angular/common';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { SearchAssistComponent } from '../search-assist/search-assist.component';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { CommonEventService } from '../services/common-event.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';


declare var require: any
const { v4: uuidv4 } = require('uuid');



@Component({
  selector: 'app-bom-assembly-process',
  templateUrl: './bom-assembly-process.component.html',
  styleUrls: ['./bom-assembly-process.component.css']
})
export class BomAssemblyProcessComponent {

  closeResult: string = '';
  showSaveItemEditOpt = false;
  
  processFlowObj = {preLoading: false, bomTable: false, bomCustomUpload: false, bomColumnScreen: false,pregeneratedLength: '', customLength: '',customBomUploadMsg: false,bomTableMsg: false};
  headerCheck = false;
  bomDataItems: any = {};
  buttonsDisabled = true;
  selectedBomObj: any;
  showLineItemEdit = false;
  editLineItemForm:any= FormGroup;
  lineItemEdit :any = 'Edit';
  lostBomItemIndex:any;
  bomId:any;
  showNoDataMsg = "Please upload a BOM to proceed";
  countDniCheck = 0;
  sqsgenerationcount = 0.0;
  uID = uuidv4();
  pageShow : any = {
    "showLevel1BomItemsData" : true,
    "showerrorFreeBomItemsData" : false
  }
  isPriceMatrixHidden = true;
  viaInPadCheckHidden = true;
  bomFileData :any;
  assemblyDefaultCheck = false;
  currentDateTime:any;
  flowActivityId:any='';
  constructor(private modalService: NgbModal,
    public apiService : ApiService,
    public commonService : CommonEventService,
    private router: Router,
    public formBuilder : FormBuilder
    ) {
      // this.editLineItemForm = this.formBuilder.group({});
      this.editLineItemForm = new FormGroup({
        item_num: new FormControl('', [Validators.required,Validators.minLength(1),Validators.maxLength(100)]),
        quantity:new FormControl('',[Validators.required,Validators.minLength(1),Validators.maxLength(100)]),
        ref_designators:new FormControl('',[Validators.required,Validators.minLength(1),Validators.maxLength(100)]),
        do_not_install:new FormControl('',[]),
        mpn:new FormControl('',[Validators.required,Validators.minLength(1)]),
        manufacturer:new FormControl({value:'',"disabled":false},[]),
        vpn:new FormControl({value:'',"disabled":false},[]),
        vendor:new FormControl({value:'',"disabled":false},[]),
        footprint:new FormControl({value:'',"disabled":false},[]),
        value:new FormControl({value:'',"disabled":false},[]),
        description:new FormControl({value:'',"disabled":false},[]),
    })
  }

  ngOnInit(){
    window.scrollTo(0, 0);
    this.commonService.restrictBrowserButtons();
    this.commonService.restrictRefreshButton();
    this.commonService.formattingCurrentDateTime(); 
    this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
    this.assemblyPriceData();
  }
  
  ngOnDestroy() {
    this.commonService.destroyRefreshEvent();
  }

  checkAssemblyPrice(turntime:any,quantity:any,price:any){
    this.commonService.commonMainObj.selectedAssemblyTurntime  = turntime;
    this.commonService.commonMainObj.selectedAssemblyQuantity  = quantity;
    this.commonService.commonMainObj.selectedAssemblyPrice  = price;
    if(turntime < 7 && this.commonService.commonMainObj.viaInPadData == 'Yes'){
      this.viaInPadCheckHidden = false;
    }else{
      this.viaInPadCheckHidden = true;
    }
    $('#assembly-quote-proceed-btn').prop("disabled",false);
    this.commonService.commonMainObj.onlyPcb = false;
  }

  assemblyPriceData(){
    let columns = [];
    let calusCount = 0;
    columnloop: for (let m of this.commonService.commonMainObj.assemblyQuoteJson) {
      let field = m.turnTime;
      if(parseInt(m.assemblyLabor)>0){
        for (let c of columns) if (c.field == field) continue columnloop;
        columns.push({field: field, title: m.turnTime});
      }
      
    }
    let rows:any = [];
    let i=0;
    rowloop: for (let m of this.commonService.commonMainObj.assemblyQuoteJson) {
      let turnTimeQuantity = m.quantity;
      let row:any;
      for (let r of rows) {
          if (r.turnTimeQuantity == turnTimeQuantity) {
              row = r;
              break;
          }
      }
      if (parseInt(m.assemblyLabor)>0) {
          calusCount++
      }
      if (!row) rows.push(row = {turnTimeQuantity: turnTimeQuantity});
      row[m.turnTime] = m.assemblyLabor;
      i++;
    }
    this.commonService.commonMainObj.assemblyMatrixColData = columns;
    this.commonService.commonMainObj.assemblyMatrixRowData = rows;
    //OFP-764 related to this ticket 2nd point
    console.log("DATA LENGTH",this.commonService.commonMainObj.assemblyMatrixColData)
    if(this.commonService.commonMainObj.assemblyMatrixColData.length == 1){
      this.assemblyDefaultCheck = true;
      this.checkAssemblyPrice(this.commonService.commonMainObj.assemblyMatrixColData[0].field,this.commonService.commonMainObj.assemblyMatrixRowData[0].turnTimeQuantity,this.commonService.commonMainObj.assemblyMatrixRowData[0][this.commonService.commonMainObj.assemblyMatrixColData[0].field])
      //$('#panel-main-get-quote-assembly-matrix-turnTimeQuantity').attr('checked');
    }else{
      this.assemblyDefaultCheck = false;
      //$('#panel-main-get-quote-assembly-matrix-turnTimeQuantity').removeAttr('checked');
    }
    if(calusCount > 0){
      this.commonService.commonMainObj.noPriceForTurntimeQtyCombination = false;
      var assemblyPricingData={
        "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
      }
      this.apiService.updateDetailsToDashboard(this.flowActivityId,assemblyPricingData,'AssemblyLabourPricingPage').subscribe((resDatas)=>{
      // console.log("updateDetailsToDashboard",resDatails);
      })
    }else{
      this.commonService.commonMainObj.uploadedBomFileName = this.commonService.commonMainObj.uploadedFile?this.commonService.commonMainObj.uploadedFile.name:'';
      this.commonService.commonMainObj.noPriceForTurntimeQtyCombination = true;
      this.commonService.commonMainObj.pcbType = "Custom/Advanced PCB";
      // this.commonService.commonMainObj.customQuoteParam = pebResData.customQuoteParameters;
      this.router.navigateByUrl('/quoteDetails');
    }

  }

  navigateToQuoteDetailsSessionChecked(assemblyPriceData:any){
    if(assemblyPriceData){
      this.commonService.commonMainObj.pcbFinalQuotedata = assemblyPriceData;
      // console.log("this.commonService.commonMainObj.pcbFinalQuotedata",this.commonService.commonMainObj.pcbFinalQuotedata);
      this.commonService.commonMainObj.uploadedBomFileName = this.commonService.commonMainObj.uploadedFile?this.commonService.commonMainObj.uploadedFile.name:'';
      this.router.navigateByUrl('/quoteDetails');
    }
  }

  navigateToQuoteDetails(){
    if(this.commonService.commonMainObj.onlyPcb == true){
      this.commonService.showtoast('Please select Assembly Labor price to proceed','warning');
      return false;
    }
    this.commonService.sessionPortalLoad();
    var finalQuotedataObj ={
      "pcbQuantity": this.commonService.commonMainObj.selectedFabQuantity,
      "pcbTurntime": this.commonService.commonMainObj.selectedFabTurntimeVal,
      "assemblyQuantity": this.commonService.commonMainObj.selectedAssemblyQuantity,
      "assemblyTurntime": this.commonService.commonMainObj.selectedAssemblyTurntime
    }
    finalQuotedataObj.assemblyTurntime = finalQuotedataObj.assemblyTurntime.split(' ')[0]
    this.commonService.loadingShow();
    this.apiService.createAssemblyFabFinalQuote(finalQuotedataObj).subscribe((assemblyPriceData:any) => {
      this.commonService.loadingHide();
      if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.sessionPortalLoad();
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          if(data.status == 1){
            this.navigateToQuoteDetailsSessionChecked(assemblyPriceData);
          }
        },error =>{
          console.log('Error in checking user session', error);   
        })
      }else{
        this.navigateToQuoteDetailsSessionChecked(assemblyPriceData);
      }
    },error => {
      this.commonService.loadingHide();
      console.log("Error in getting PCB final quote",error);
    });
  }


}
